<script lang="ts">
  import OutputLines from './OutputLines.svelte';
  import { diffLines, plainLines, stripVizLines } from './output-lines';

  interface Props {
    mode: 'plain' | 'diff';
    stdout?: string;
    stderr?: string;
    expected?: string;
    actual?: string;
    durationMs?: number;
    showWhitespace?: boolean;
  }

  let {
    mode,
    stdout = '',
    stderr = '',
    expected = '',
    actual = '',
    durationMs,
    showWhitespace = $bindable(false),
  }: Props = $props();

  const diff = $derived(diffLines(expected, actual));
  const stdoutLines = $derived(plainLines(stdout));
  const stderrText = $derived(stripVizLines(stderr).replace(/\n+$/, ''));
</script>

<section class="output-panel" aria-label="出力" data-testid="output-panel">
  <div class="toolbar">
    <label class="ws-toggle">
      <input type="checkbox" bind:checked={showWhitespace} />
      空白と改行を表示
    </label>
    {#if durationMs !== undefined}
      <span class="duration num">{durationMs.toLocaleString('ja-JP')} ms</span>
    {/if}
  </div>

  {#if mode === 'diff'}
    <div class="diff">
      <div>
        <h3>期待する出力</h3>
        <OutputLines lines={diff.expected} side="expected" {showWhitespace} label="期待する出力" />
      </div>
      <div>
        <h3>あなたの出力</h3>
        <OutputLines lines={diff.actual} side="actual" {showWhitespace} label="あなたの出力" />
      </div>
    </div>
  {:else}
    <div>
      <h3>標準出力</h3>
      <OutputLines lines={stdoutLines} {showWhitespace} label="標準出力" />
    </div>
  {/if}

  {#if stderrText !== ''}
    <div>
      <h3>標準エラー出力</h3>
      <!-- svelte-ignore a11y_no_noninteractive_tabindex -->
      <pre class="output stderr" tabindex="0" aria-label="標準エラー出力">{stderrText}</pre>
    </div>
  {/if}
</section>

<style>
  .output-panel {
    display: flex;
    flex-direction: column;
    gap: var(--space-3);
    min-width: 0;
  }
  .toolbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: var(--space-3);
    flex-wrap: wrap;
    font-size: var(--fs-sm);
  }
  .ws-toggle {
    display: inline-flex;
    align-items: center;
    gap: var(--space-2);
    min-height: var(--tap-min);
    font-weight: var(--fw-regular);
    color: var(--text-soft);
  }
  .duration {
    color: var(--text-soft);
  }
  .diff {
    display: grid;
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
    gap: var(--space-3);
  }
  h3 {
    font-size: var(--fs-sm);
    color: var(--text-soft);
    font-weight: var(--fw-semibold);
    margin-bottom: var(--space-1);
  }
  .stderr {
    color: var(--err-text);
    background: var(--err-bg);
    border-color: transparent;
  }
  @media (max-width: 639px) {
    .diff {
      grid-template-columns: minmax(0, 1fr);
    }
  }
</style>
